import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "infobox" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { Place } from "@wwtelescope/engine";

interface Props {
  place: Place | null;
  showReadMore?: boolean;
  small?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Infobox',
  props: {
    place: {},
    showReadMore: { type: Boolean, default: true },
    small: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_expansion_wrapper = _resolveComponent("expansion-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.small)
      ? (_openBlock(), _createBlock(_component_v_overlay, {
          key: 0,
          absolute: "",
          opacity: "0.6",
          class: "infobox-overlay",
          scrim: "#00000030"
        }, {
          activator: _withCtx(({ props: activatorProps }) => [
            _createElementVNode("strong", _mergeProps(activatorProps, { class: "infobox-mobile infobox-activator" }), _toDisplayString(__props.place?.get_name()), 17)
          ]),
          default: _withCtx(() => [
            _createElementVNode("article", {
              class: "infobox-mobile infobox-content",
              innerHTML: __props.place?.htmlDescription
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }))
      : (__props.place != null)
        ? (_openBlock(), _createBlock(_component_expansion_wrapper, {
            key: 1,
            class: "infobox-content",
            "normally-open": false,
            title: __props.place.get_name()
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: __props.place.htmlDescription
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true)
  ]))
}
}

})